(function () {const originalFetch = window.fetch;
  const getCookie = (name) => {
    const match = document.cookie.match(
      new RegExp("(^| )" + name + "=([^;]+)")
    );
    return match ? decodeURIComponent(match[2]) : null;
  };

  window.fetch = async function () {
    const response = await originalFetch.apply(this, arguments);

    try {
      const url = arguments[0];

      // Detect Shopify add-to-cart request
      if (typeof url === "string" && url.includes("/cart/add")) {
        const cloned = response.clone();
        const data = await cloned.json();
        const handle = data?.handle || "";

        const utmParams = [
          "utm_source",
          "utm_medium",
          "utm_campaign",
          "utm_term",
          "utm_content"
        ];

        const utmEventData = {};

        utmParams.forEach((param) => {
          const value = getCookie(param);

          if (value) {
            const key = param.replace("utm_", "");
            utmEventData[key] = value;
          }
        });

        // ---- VORTA ----
        if (handle.includes("nuvy-smoothing-multi-styler")) {
          if (typeof window.gtag === "function") {
            gtag("event", "add_to_cart_vorta", {
              item_name: data?.product_title,
              value: data?.price ? data.price / 100 : undefined,
              ...utmEventData
            });
          }
        }

        // ---- NOVA ----
        if (handle.includes("nuvy-shaver")) {
          if (typeof window.gtag === "function") {
            gtag("event", "add_to_cart_nova", {
              item_name: data?.product_title,
              value: data?.price ? data.price / 100 : undefined,
              ...utmEventData
            });
          }
        }
      }
    } catch (err) {
      console.warn("[GTM] fetch intercept error:", err);
    }

    return response;
  };
})();

